import { createApi } from 'swag-client-common/libs/rapi';
export const CollectSizesApi = createApi({
  checkIfCreatedBefore: {
    url: '/api/v1/collect-sizes/check-if-created-before',
    method: 'get'
  }
});